/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Change detection enables data binding in Angular.
 */

export {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  DefaultIterableDiffer,
  IterableChangeRecord,
  IterableChanges,
  IterableDiffer,
  IterableDifferFactory,
  IterableDiffers,
  KeyValueChangeRecord,
  KeyValueChanges,
  KeyValueDiffer,
  KeyValueDifferFactory,
  KeyValueDiffers,
  NgIterable,
  PipeTransform,
  SimpleChange,
  SimpleChanges,
  TrackByFunction,
} from './change_detection/change_detection';
